import React from 'react';
import { Tooltip } from '@mui/material';

/**
 * Wraps a grid cell with a hover tooltip when title is non-empty.
 * Child must accept a ref (e.g. MUI Paper / Box).
 */
export default function StatusCellTooltip({ title, children, placement = 'top' }) {
  if (!title) return children;

  return (
    <Tooltip
      title={
        <span style={{ whiteSpace: 'pre-line', display: 'block', lineHeight: 1.35 }}>
          {title}
        </span>
      }
      arrow
      enterDelay={200}
      enterNextDelay={100}
      placement={placement}
    >
      {children}
    </Tooltip>
  );
}
